export function startInstall(nonce) {
    const formData = new FormData();
    const ajaxUrl = window.ajaxurl;
    formData.append('_wpnonce', nonce);
    formData.append('action', 'content_embed_install');
    return fetch(ajaxUrl, {
        method: 'POST',
        body: formData,
        keepalive: true,
    }).then(res => res.json());
}
export function startActivation(requestUrl) {
    return fetch(requestUrl, {
        method: 'POST',
        keepalive: true,
    }).then(res => res.json());
}
